import { c as _c } from "react/compiler-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { FormActions } from "@/app/(security)/inscription/components/form-actions";
import FormPartTitle from "@/components/form/form-part-title";
import { FormInput } from "@/components/global/form/inputs/form-input";
import { useModalStore } from "@/stores/modal-store";
import { SocialNetwork } from "@/TS/Interfaces/global_interfaces";
import { useSocialNetwork } from "../hooks/use-social-network";
import { editSocialNetworkSchemaValues, editSocialNetworkSchema } from "./modal/social-network/schema";
export interface EditSocialNetworkFormData {
  facebook: string;
  linkedin: string;
  x: string;
  messaging: string;
}
interface ModalSocialNetworkProps {
  clubSlug: string;
}
export const ModalSocialNetwork = t0 => {
  const $ = _c(60);
  const {
    clubSlug
  } = t0;
  const {
    close
  } = useModalStore();
  const queryClient = useQueryClient();
  let t1;
  if ($[0] !== clubSlug || $[1] !== queryClient) {
    t1 = queryClient.getQueryData(["club", clubSlug, "socialNetwork"]);
    $[0] = clubSlug;
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const socialNetworkQueries = t1;
  const {
    mutate: updateSocialNetwork,
    error: errorSocialNetwork,
    isSuccess: isSuccessSocialNetwork,
    isPending: isPendingSocialNetwork
  } = useSocialNetwork(clubSlug);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = zodResolver(editSocialNetworkSchema);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = socialNetworkQueries?.facebook || "";
  const t4 = socialNetworkQueries?.linkedin || "";
  const t5 = socialNetworkQueries?.x || "";
  const t6 = socialNetworkQueries?.messaging || "";
  let t7;
  if ($[4] !== t3 || $[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
    t7 = {
      mode: "onSubmit",
      reValidateMode: "onChange",
      resolver: t2,
      defaultValues: {
        facebook: t3,
        linkedin: t4,
        x: t5,
        messaging: t6
      }
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const methods = useForm(t7);
  const {
    handleSubmit,
    formState: t8
  } = methods;
  const {
    errors,
    isSubmitted
  } = t8;
  let t9;
  if ($[9] !== updateSocialNetwork) {
    t9 = data => {
      updateSocialNetwork({
        facebook: data.facebook?.trim() || "",
        linkedin: data.linkedin?.trim() || "",
        x: data.x?.trim() || "",
        messaging: data.messaging?.trim() || ""
      });
    };
    $[9] = updateSocialNetwork;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const onSubmit = t9;
  let t10;
  let t11;
  if ($[11] !== close || $[12] !== isSuccessSocialNetwork) {
    t10 = () => {
      if (isSuccessSocialNetwork) {
        const timer = setTimeout(() => {
          close();
        }, 3000);
        return () => clearTimeout(timer);
      }
    };
    t11 = [isSuccessSocialNetwork, close];
    $[11] = close;
    $[12] = isSuccessSocialNetwork;
    $[13] = t10;
    $[14] = t11;
  } else {
    t10 = $[13];
    t11 = $[14];
  }
  useEffect(t10, t11);
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <FormPartTitle className="text-center">Réseaux sociaux</FormPartTitle>;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== handleSubmit || $[17] !== onSubmit) {
    t13 = handleSubmit(onSubmit);
    $[16] = handleSubmit;
    $[17] = onSubmit;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      backgroundColor: "#FEFAF5",
      width: "100%",
      height: "100%"
    };
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const t15 = `Pour plus de visibilité nous vous recommandons la structure suivante : https://www.linkedin.com/company/${clubSlug}`;
  let t16;
  let t17;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      sx: {
        zIndex: 10000
      }
    };
    t17 = <InfoIcon fontSize="small" className="text-gray-400" />;
    $[20] = t16;
    $[21] = t17;
  } else {
    t16 = $[20];
    t17 = $[21];
  }
  let t18;
  if ($[22] !== t15) {
    t18 = <div className="flex items-center gap-2">Lien Linkedin<Tooltip title={t15} placement="right" PopperProps={t16}>{t17}</Tooltip></div>;
    $[22] = t15;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  const t19 = `https://www.linkedin.com/company/${clubSlug}`;
  const t20 = errors.linkedin?.message;
  const t21 = isSubmitted && !errors.linkedin;
  let t22;
  if ($[24] !== t18 || $[25] !== t19 || $[26] !== t20 || $[27] !== t21) {
    t22 = <div className="flex flex-col gap-2"><FormInput name="linkedin" label={t18} placeholder={t19} error={t20} isValid={t21} dataCy="linkedin" /></div>;
    $[24] = t18;
    $[25] = t19;
    $[26] = t20;
    $[27] = t21;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  const t23 = errors.facebook?.message;
  const t24 = isSubmitted && !errors.facebook;
  let t25;
  if ($[29] !== t23 || $[30] !== t24) {
    t25 = <div className="flex flex-col gap-2"><FormInput name="facebook" label="Lien Facebook" placeholder="https://www.facebook.com/" error={t23} isValid={t24} dataCy="facebook" /></div>;
    $[29] = t23;
    $[30] = t24;
    $[31] = t25;
  } else {
    t25 = $[31];
  }
  const t26 = errors.x?.message;
  const t27 = isSubmitted && !errors.x;
  let t28;
  if ($[32] !== t26 || $[33] !== t27) {
    t28 = <div className="flex flex-col gap-2"><FormInput name="x" label="Lien X" placeholder="https://x.com/" error={t26} isValid={t27} dataCy="x" /></div>;
    $[32] = t26;
    $[33] = t27;
    $[34] = t28;
  } else {
    t28 = $[34];
  }
  let t29;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <div className="flex items-center gap-2">Lien Messagerie<Tooltip title={"Lien vers votre groupe ou communaut\xE9 de messagerie (WhatsApp, Telegram\u2026)."} placement="right" PopperProps={{
        sx: {
          zIndex: 10000
        }
      }}><InfoIcon fontSize="small" className="text-gray-400" /></Tooltip></div>;
    $[35] = t29;
  } else {
    t29 = $[35];
  }
  const t30 = errors.messaging?.message;
  const t31 = isSubmitted && !errors.messaging;
  let t32;
  if ($[36] !== t30 || $[37] !== t31) {
    t32 = <div className="flex flex-col gap-2"><FormInput name="messaging" label={t29} placeholder="https://chat.whatsapp.com/..." error={t30} isValid={t31} dataCy="messaging" /></div>;
    $[36] = t30;
    $[37] = t31;
    $[38] = t32;
  } else {
    t32 = $[38];
  }
  let t33;
  if ($[39] !== t22 || $[40] !== t25 || $[41] !== t28 || $[42] !== t32) {
    t33 = <div className="flex flex-col gap-4 p-4" style={t14}>{t22}{t25}{t28}{t32}</div>;
    $[39] = t22;
    $[40] = t25;
    $[41] = t28;
    $[42] = t32;
    $[43] = t33;
  } else {
    t33 = $[43];
  }
  let t34;
  if ($[44] !== errorSocialNetwork) {
    t34 = errorSocialNetwork && <div style={{
      color: "#EE4540",
      fontWeight: "bold",
      fontSize: "14px"
    }}>{errorSocialNetwork.message}</div>;
    $[44] = errorSocialNetwork;
    $[45] = t34;
  } else {
    t34 = $[45];
  }
  let t35;
  if ($[46] !== isSuccessSocialNetwork) {
    t35 = isSuccessSocialNetwork && <div className="text-center text-success2 font-medium py-2 bg-success rounded-lg animate-fadeIn" style={{
      width: "100%"
    }}>Réseaux sociaux mis à jour avec succès !</div>;
    $[46] = isSuccessSocialNetwork;
    $[47] = t35;
  } else {
    t35 = $[47];
  }
  let t36;
  if ($[48] !== close || $[49] !== isPendingSocialNetwork) {
    t36 = <FormActions isPending={isPendingSocialNetwork} closeModal={close} submitLabel="Valider" />;
    $[48] = close;
    $[49] = isPendingSocialNetwork;
    $[50] = t36;
  } else {
    t36 = $[50];
  }
  let t37;
  if ($[51] !== t13 || $[52] !== t33 || $[53] !== t34 || $[54] !== t35 || $[55] !== t36) {
    t37 = <form onSubmit={t13} className="w-full flex flex-col gap-4 justify-center items-center">{t33}{t34}{t35}{t36}</form>;
    $[51] = t13;
    $[52] = t33;
    $[53] = t34;
    $[54] = t35;
    $[55] = t36;
    $[56] = t37;
  } else {
    t37 = $[56];
  }
  let t38;
  if ($[57] !== methods || $[58] !== t37) {
    t38 = <div className="flex flex-col gap-4 w-full justify-center items-center">{t12}<FormProvider {...methods}>{t37}</FormProvider></div>;
    $[57] = methods;
    $[58] = t37;
    $[59] = t38;
  } else {
    t38 = $[59];
  }
  return t38;
};